// Generated from tools/supplier-catalog/commerce-taxonomy.json.
/** Browsing groups do not establish exact machine fitment. */
export const ATTACHMENT_MACHINE_TYPES = [
  {
    "handle": "skid-steer",
    "name": "Skid Steer",
    "description": "Browse attachments for skid steer machines."
  },
  {
    "handle": "mini-skid-steer",
    "name": "Mini Skid Steer",
    "description": "Browse attachments for mini skid steer machines."
  },
  {
    "handle": "excavator",
    "name": "Excavator",
    "description": "Browse attachments for excavator machines."
  },
  {
    "handle": "mini-excavator",
    "name": "Mini Excavator",
    "description": "Browse attachments for mini excavator machines."
  },
  {
    "handle": "forklift",
    "name": "Forklift",
    "description": "Browse attachments for forklift machines."
  },
  {
    "handle": "telehandler",
    "name": "Telehandler",
    "description": "Browse attachments for telehandler machines."
  },
  {
    "handle": "wheel-loader",
    "name": "Wheel Loader",
    "description": "Browse attachments for wheel loader machines."
  },
  {
    "handle": "compact-wheel-loader",
    "name": "Compact Wheel Loader",
    "description": "Browse attachments for compact wheel loader machines."
  },
  {
    "handle": "dozer",
    "name": "Dozer",
    "description": "Browse attachments for dozer machines."
  },
  {
    "handle": "motor-grader",
    "name": "Motor Grader",
    "description": "Browse attachments for motor grader machines."
  },
  {
    "handle": "backhoe-loader",
    "name": "Backhoe Loader",
    "description": "Browse attachments for backhoe loader machines."
  },
  {
    "handle": "smooth-drum-roller",
    "name": "Smooth Drum Roller",
    "description": "Browse attachments for smooth drum roller machines."
  },
  {
    "handle": "tractor",
    "name": "Tractor",
    "description": "Browse attachments for tractor machines."
  }
];
